/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {OnboardSavingsYieldCustomerRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {OnboardSavingsYieldCustomerResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const onboardSavingsYieldCustomer = (request: OnboardSavingsYieldCustomerRequest, options?: CashRequestOptions) => post<OnboardSavingsYieldCustomerRequest, OnboardSavingsYieldCustomerResponse>("/2.0/cash/onboard-savings-yield-customer", request, {...options, rejectOnError: true })